// NAVIGATION
function navigate(page) {
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  document.getElementById('page-' + page).classList.add('active');
  document.querySelectorAll('.nav-links a').forEach(a => {
    a.classList.toggle('active', a.dataset.page === page);
  });
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

// MOBILE MENU
function toggleMenu() {
  document.getElementById('navLinks').classList.toggle('open');
}

function closeMenu() {
  document.getElementById('navLinks').classList.remove('open');
}

// SCROLL NAV
window.addEventListener('scroll', () => {
  document.getElementById('mainNav').classList.toggle('scrolled', window.scrollY > 60);
});

// TOAST
function showToast(msg) {
  const t = document.getElementById('toast');
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3500);
}

// CORE AJAX SUBMIT — reads endpoint from data-formspree, never redirects
async function sendToFormspree(form) {
  const endpoint = form.getAttribute('data-formspree');
  const data = new FormData(form);
  const response = await fetch(endpoint, {
    method: 'POST',
    body: data,
    headers: { 'Accept': 'application/json' }
  });
  return response.ok;
}

// EMAIL SIGNUP
function submitEmail(e) {
  e.preventDefault();
  const form = e.target;
  sendToFormspree(form).then(ok => {
    if (ok) {
      form.reset();
      showToast("You're on the list. Welcome to the circle.");
    } else {
      showToast("Something went wrong. Please try again.");
    }
  });
}

// RSVP FORM
function submitRSVP(e) {
  e.preventDefault();
  const form = e.target;
  sendToFormspree(form).then(ok => {
    if (ok) {
      document.getElementById('rsvp-form').style.display = 'none';
      document.getElementById('rsvp-success').classList.add('show');
      showToast("You're on the list.");
    } else {
      showToast("Something went wrong. Please try again.");
    }
  });
}

// MEMBERSHIP APPLICATION
function submitMembership(e) {
  e.preventDefault();
  const form = e.target;
  const btn = form.querySelector('button[type="submit"]');
  btn.textContent = 'Submitting...';
  btn.disabled = true;
  sendToFormspree(form).then(ok => {
    if (ok) {
      document.getElementById('membership-form').style.display = 'none';
      document.getElementById('membership-success').classList.add('show');
      showToast("Application received — welcome to Inner Cirq.");
    } else {
      btn.textContent = 'Submit Application';
      btn.disabled = false;
      showToast("Something went wrong. Please try again.");
    }
  });
}

// CONTACT FORM
function submitContact(e) {
  e.preventDefault();
  const form = e.target;
  const btn = form.querySelector('button[type="submit"]');
  btn.textContent = 'Sending...';
  btn.disabled = true;
  sendToFormspree(form).then(ok => {
    if (ok) {
      document.getElementById('contact-form').style.display = 'none';
      document.getElementById('contact-success').classList.add('show');
      showToast("Message sent. We'll be in touch.");
    } else {
      btn.textContent = 'Send Message';
      btn.disabled = false;
      showToast("Something went wrong. Please try again.");
    }
  });
}

// DONATE FORM
function submitDonate(e) {
  e.preventDefault();
  document.getElementById('donate-form').style.display = 'none';
  document.getElementById('donate-success').classList.add('show');
  showToast("Thank you for your generosity.");
}

// DONATE AMOUNT SELECT
function selectAmount(btn, amount) {
  document.querySelectorAll('.amount-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}